module.exports = __webpack_public_path__ + "img/icon-close-button-cross.2b7e2414.svg";